



















































































































































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator'
import { WidgetFlowType, WidgetFont, WidgetGoal, WidgetGoalType, WidgetPopupAnimation, WidgetPopupContent, WidgetPopupPosition, WidgetPopupType, WidgetType } from '@/api/types'
import { Company } from '@/api/model/company'

interface SelectOptions {
    label: string,
    value: string
}

@Component
export default class EditEmmaWidgetForm extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>

    @Prop({ required: true }) readonly company: Company

    onGoalSelect(inputValue, currentValue: WidgetGoal): object {
        const internalValue = currentValue

        internalValue.type = inputValue

        return internalValue
    }

    onCustomInput(inputValue, currentValue: WidgetGoal): object {
        const internalValue = currentValue

        internalValue.custom = inputValue

        return internalValue
    }

    onLabelInput(inputValue, currentValue: WidgetGoal): object {
        const internalValue = currentValue

        internalValue.label = inputValue

        return internalValue
    }

    hasCustomInput(type: WidgetGoalType): boolean {
        const customArray = [
            WidgetGoalType.CALL,
            WidgetGoalType.EMAIL,
            WidgetGoalType.CUSTOM,
        ]

        return customArray.includes(type)
    }

    customInputPlaceholders(type: WidgetGoalType): string {
        const placeholders: { [k in WidgetGoalType]?: string } = {}

        placeholders[WidgetGoalType.CALL] = this.$t('forms.edit_emma_widget_form.goal.placeholders.call').toString()
        placeholders[WidgetGoalType.EMAIL] = this.$t('forms.edit_emma_widget_form.goal.placeholders.email').toString()
        placeholders[WidgetGoalType.CUSTOM] = this.$t('forms.edit_emma_widget_form.goal.placeholders.custom').toString()

        return placeholders[type]
    }

    getContentTranslation(flow: WidgetFlowType, line: string): string {
        return this.$t([
            'forms.edit_emma_widget_form.popup.content',
            line,
            'default',
            flow,
        ].join('.')).toString()
    }

    getPopupContent(flow: WidgetFlowType): WidgetPopupContent {

        let flowContent: WidgetPopupContent = this.company.widgetPopupContents.find(item => item.flow === flow)

        if (!flowContent) {
            flowContent = {
                flow,
                button: this.getContentTranslation(flow, 'button'),
                line1: this.getContentTranslation(flow, 'line1'),
                line2: this.getContentTranslation(flow, 'line2'),
                line3: this.getContentTranslation(flow, 'line3'),
                line4: this.getContentTranslation(flow, 'line4'),
            }

            this.company.widgetPopupContents.push(flowContent)
        }

        return flowContent
    }

    setPopupContent(flow: WidgetFlowType, field, event) {

        const content = this.company.widgetPopupContents.find(item => item.flow === flow)
        content[field] = event
    }

    setWidgetPopupOpenTime(event) {
        this.company.widgetPopupOpenTime = parseFloat(event)
    }

    get widgetFlowTypes(): SelectOptions[] {
        return [{
            label: this.$t('forms.edit_emma_widget_form.flows.agent').toString(),
            value: WidgetFlowType.AGENT,
        }, {
            label: this.$t('forms.edit_emma_widget_form.flows.information').toString(),
            value: WidgetFlowType.INFORMATION,
        }, {
            label: this.$t('forms.edit_emma_widget_form.flows.valuation').toString(),
            value: WidgetFlowType.VALUATION,
        }, {
            label: this.$t('forms.edit_emma_widget_form.flows.checklist').toString(),
            value: WidgetFlowType.CHECKLIST,
        }]
    }

    get activatedWidgetFlowTypes(): SelectOptions[] {
        return this.widgetFlowTypes.filter(selectOption => {
            return this.company.activatedWidgetFlowTypes.includes(selectOption.value as WidgetFlowType)
        })
    }

    get widgetTypes(): SelectOptions[] {
        const types = [
            {
                label: this.$t('forms.edit_emma_widget_form.type.avatar').toString(),
                value: WidgetType.AVATAR,
            },
            {
                label: this.$t('forms.edit_emma_widget_form.type.popup').toString(),
                value: WidgetType.POPUP,
            },
        ]

        return types
    }

    get widgetPopupTypes(): SelectOptions[] {
        return [{
            label: this.$t('forms.edit_emma_widget_form.popup.type.rectangle').toString(),
            value: WidgetPopupType.RECTANGLE,
        }, {
            label: this.$t('forms.edit_emma_widget_form.popup.type.circular').toString(),
            value: WidgetPopupType.CIRCULAR,
        }, {
            label: this.$t('forms.edit_emma_widget_form.popup.type.card').toString(),
            value: WidgetPopupType.CARD,
        }]
    }

    get widgetPopupPositions(): SelectOptions[] {
        return [{
            label: this.$t('forms.edit_emma_widget_form.popup.side.left').toString(),
            value: WidgetPopupPosition.LEFT,
        }, {
            label: this.$t('forms.edit_emma_widget_form.popup.side.right').toString(),
            value: WidgetPopupPosition.RIGHT,
        }]
    }

    get widgetPopupAnimations(): SelectOptions[] {
        const animations: SelectOptions[] = [{
            label: this.$t('forms.edit_emma_widget_form.popup.animation.none').toString(),
            value: WidgetPopupAnimation.NONE,
        }]

        if (this.company.widgetPopupType !== WidgetPopupType.CARD) {
            animations.push({
                label: this.$t('forms.edit_emma_widget_form.popup.animation.open').toString(),
                value: WidgetPopupAnimation.OPEN,
            })
        }

        return animations
    }

    get widgetPopupFonts(): SelectOptions[] {
        return [{
            label: this.$t('forms.edit_emma_widget_form.popup.font.roboto').toString(),
            value: WidgetFont.ROBOTO,
        }, {
            label: this.$t('forms.edit_emma_widget_form.popup.font.opensans').toString(),
            value: WidgetFont.OPENSANS,
        }, {
            label: this.$t('forms.edit_emma_widget_form.popup.font.montserrat').toString(),
            value: WidgetFont.MONTSERRAT,
        }]
    }

    @Watch('company.widgetPopupType')
    watchWidgetType() {
        if (this.company.widgetPopupType === WidgetPopupType.CARD) {
            this.company.widgetPopupAnimation = WidgetPopupAnimation.NONE
        }
    }

    goalTypes(values: WidgetGoal[], currentValue: WidgetGoal): SelectOptions[] {
        const types = [{
            label: this.$t('forms.edit_emma_widget_form.goal.call').toString(),
            value: WidgetGoalType.CALL,
        }, {
            label: this.$t('forms.edit_emma_widget_form.goal.email').toString(),
            value: WidgetGoalType.EMAIL,
        }]

        if (
            !values.find(value => value.type === WidgetGoalType.CUSTOM) ||
            currentValue.type === WidgetGoalType.CUSTOM
        ) {
            types.push({
                label: this.$t('forms.edit_emma_widget_form.goal.custom').toString(),
                value: WidgetGoalType.CUSTOM,
            })
        }

        if (this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.VALUATION)) {
            types.push({
                label: this.$t('forms.edit_emma_widget_form.goal.valuation').toString(),
                value: WidgetGoalType.VALUATION,
            })
        }

        if (this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.CHECKLIST)) {
            types.push({
                label: this.$t('forms.edit_emma_widget_form.goal.checklist').toString(),
                value: WidgetGoalType.CHECKLIST,
            })
        }

        if (this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.AGENT)) {
            types.push({
                label: this.$t('forms.edit_emma_widget_form.goal.agent').toString(),
                value: WidgetGoalType.AGENT,
            })
        }

        if (this.company.activatedWidgetFlowTypes.includes(WidgetFlowType.INFORMATION)) {
            types.push({
                label: this.$t('forms.edit_emma_widget_form.goal.information').toString(),
                value: WidgetGoalType.INFORMATION,
            })
        }

        return types
    }

    get isAvatarWidget(): boolean {
        return this.company.widgetType === WidgetType.AVATAR && this.company.widgetEnabled
    }

    get isPopupWidget(): boolean {
        return this.company.widgetType === WidgetType.POPUP && this.company.widgetEnabled
    }

    get hasOpenAnimation(): boolean {
        return this.company.widgetPopupAnimation === WidgetPopupAnimation.OPEN
    }

    /** declare what row / span in the grid the slot should show */
    get slotStyle(): object {
        return {
            'grid-row-start': this.company.widgetType === WidgetType.POPUP ? 3 : 1,
            'grid-row-end': this.company.widgetType === WidgetType.POPUP ? 6 : 4,
        }
    }

    get defaultWidgetGoal(): WidgetGoal {
        return {
            type: WidgetGoalType.CALL,
            custom: '',
            label: '',
        }
    }
}
